import React from 'react';
import { bool, string, func } from 'prop-types';

import { ArrowLeft } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';

import EditAddress from 'components/Address/EditAddress';

import styles from '../ChooseAddressModal.scss';

const EditAddressView = ({
  editAddressTitle = 'Edit Address',
  ukOnlyAddress = false,
  onAfterSubmit,
  onBackClick,
  manualOnly = true,
}) => (
  <section className={styles.crudForm} data-test="edit-address">
    <TextLink className={styles.backLink} component="button" onClick={onBackClick}>
      <ArrowLeft />
      Back
    </TextLink>
    <EditAddress
      onAfterSubmit={onAfterSubmit}
      pageTitle={editAddressTitle}
      ukOnlyAddress={ukOnlyAddress}
      manualOnly={manualOnly}
    />
  </section>
);

EditAddressView.propTypes = {
  onAfterSubmit: func.isRequired,
  onBackClick: func.isRequired,
  editAddressTitle: string,
  ukOnlyAddress: bool,
  manualOnly: bool,
};

export default EditAddressView;
